module.exports = __webpack_public_path__ + "img/cover-3.dc3b62b9.jpg";